import { graphql } from '../gql';

export const fetchAccount = graphql(`
  query fetchAccount($accountId: ID!) {
    getAccount(id: $accountId) {
      account {
        id
        name
      }
      error {
        code
        message
      }
    }
  }
`);
